export default "__VITE_ASSET__DgAQXwZ$__"